import React from 'react';
import './Trusted.css';
import img1 from '../assetsproduct/trusted1.png';
import img2 from '../assetsproduct/trusted2.png';
import img3 from '../assetsproduct/trusted3.png';
import img4 from '../assetsproduct/trusted4.png';
import img5 from '../assetsproduct/trusted5.png';
import img6 from '../assetsproduct/trusted6.png';

export default function Trusted() {
  const cards = [
    {
      id: 1,
      img: img1,
      bg:"#FAEBEE",
      title: "Experienced Cross-Functional Product Teams",
      description: "Our product development company brings together strategists, designers, and engineers who’ve shipped real products. This depth ensures product development services stay aligned with business goals, user needs, and long-term scalability."
    },
    {
      id: 2,
      img: img2,
      bg:"#FCF2E9",
      title: "Strong Focus on Early Validation",
      description: "We rely on MVP consulting services to test ideas early, avoid costly rework, and validate assumptions. This approach helps clients invest with confidence and move forward only when the product direction is clear."
    },
    {
      id: 3,
      img: img3,
      bg:"#D9FFE4",
      title: "Clear Ownership and Accountability",
      description: "As a product development company, we assign clear ownership across every stage. Clients always know who’s responsible, what’s next, and how progress is tracked—no confusion, no handoffs, no guesswork."
    },
     {
      id: 4,
      img: img4,
      bg:"#f7f7fa",
      title: "Proven Delivery Frameworks",
      description:"Our product development services follow structured, battle-tested workflows that balance speed and quality. From planning to release, every step is designed to reduce risk, maintain stability, and keep timelines realistic."
     },
     {
      id: 5,
      img: img5,
      bg:"#f5effc",
      title: "Scalable Architecture from Day One",
      description:"Using insights from MVP consulting services, we design architectures that grow with your product. This prevents rebuilds later and ensures your platform can handle increasing users, features, and data volumes."
     },
     {
      id: 6,
      img: img6,
      bg:"#e5edf8",
      title: "Long-Term Partnership Mindset",
      description:"We work as a product development company that stays involved beyond launch. Ongoing improvements, performance tuning, and strategic support help products evolve alongside changing business and market demands."
     }
  ];

  return (
    <div id='product-trusted' className='productmainclass'>
      <div className="left">
        <h2 className="heading">
         What Sets Our Product Teams Apart
        </h2>
        <p className="subheading">
         Our product teams are known for clarity, commitment, and execution—turning complex requirements into well-structured products that perform reliably under real-world conditions and long-term growth pressure.
        </p>
      </div>
      <div className="right">
        <div className="cards">
          {cards.map((card) => (
            <div className="card" key={card.id} style={{background:card.bg}}>
              <img src={card.img} alt={card.title} />
              <h3>{card.title}</h3>
              <span>{card.description}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}